import React from 'react'
import LandingPageTopbar from '../../../components/landingPageTopbar/landingPageTopbar'
import { Outlet } from 'react-router-dom'
import Footer from '../../../components/footer/footer'
import ScrollToTopButton from '../../../components/scrollToTopButton/scrollToTopButton'

const LandingPageLayout = () => {
  return (
    <>
        <LandingPageTopbar />
        <Outlet />
        <ScrollToTopButton />
        <Footer />
    </>
  )
}

export default LandingPageLayout